'use strict'

export function initInScope($scope) {
    const $form = $scope.find('.js-strex-base-config__ajax-form');

    if($form.length){
        initFormListener($form)
    }
}

function initFormListener($form) {
    const $footerBaseData = $('.js-strex-base-config__footer');

    $form.on('success.ajax-form', () => {
        //cannot get form result from ajax - so we parse inputs
        const $radios = $form.find('input[type="radio"]:checked');
        let text = '';

        $radios.each((_, radio) => {
            if(_ === 0){
                text = radio.getAttribute('data-name')
            }else{
                text += ', ' + radio.getAttribute('data-name')
            }
        })
        $footerBaseData.text(text);
    })

    $form.trigger('success.ajax-form');
}